import React from 'react';

function LabelDescription({ description, className }) {
    return <div className={className}>
        {description}
    </div>;
}

export default LabelDescription;
